<template>
	<div>
        <div class="container">
            <div class="row section-separator">
              <div class="col-sm-12 text-center section-title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                <h2>{{ $t('service.whatIDo') }}</h2>
              </div>
              <div class="col-sm-4">
                <div class="mh-service-item shadow-1 dark-bg wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.3s; animation-name: none;">
                  <!-- <i class="fa fa-bullseye purple-color"></i> -->
                  <v-icon size="30" color="red">fa-brands fa-java</v-icon>
                  <h3>{{ $t('service.javaServerDevelopment') }}</h3>
                  <p>{{ $t('service.javaServerDevelopmentDescription') }}</p>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="mh-service-item shadow-1 dark-bg wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.5s; animation-name: none;">
                  <!-- <i class="fa fa-code iron-color"></i> -->
                  <v-icon size="30" color="green">fa-brands fa-vuejs</v-icon>
                  <h3>{{ $t('service.webFrontendDevelopment') }}</h3>
                  <p>{{ $t('service.webFrontendDevelopmentDescription') }}</p>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="mh-service-item shadow-1 dark-bg wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.7s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.7s; animation-name: none;">
                  <!-- <i class="fa fa-object-ungroup sky-color"></i> -->
                  <v-icon size="30" color="blue">fa-solid fa-server</v-icon>
                  <h3>{{ $t('service.serverDeployment') }}</h3>
                  <p>{{ $t('service.serverDeploymentDescription') }}</p>
                </div>
              </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Service.vue